import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { paths } from '../../../../routing/path';

export interface MyInvitedTeamMembersMenuItemProps {
    className?: string;
    marginLeft?: number;
}

export const MyInvitedTeamMembersMenuItem = (
    props: MyInvitedTeamMembersMenuItemProps
) => (
    <LeftMenuItem
        icon="pe-7s-add-user"
        label="My Team Members"
        to={paths.account.associates}
        className={props.className}
        marginLeft={props.marginLeft}
        trackingAction="My Team Members"
    />
);
